import { Store } from 'flux/utils';
import SessionDispatcher from '../dispatchers/SessionDispatcher';

import { fetchAssignmentForEditor } from './AssignmentStore';

class SessionStore extends Store<{}> {
  private email: string = '';
  private loggedIn: boolean = false;

  getEmail(): string {
    return this.email;
  }

  isLoggedIn(): boolean {
    return this.loggedIn;
  }

  __onDispatch(payload: DispatchPayload) {
    if (payload.source === 'LOGGED_IN') {
      this.email = payload.output;
      this.loggedIn = true;
      fetchAssignmentForEditor(payload.output);
      this.__emitChange();
    } else if (payload.source === 'LOGGED_OUT') {
      this.email = '';
      this.loggedIn = false;
      this.__emitChange();
    }
  }
}

const instance = new SessionStore(SessionDispatcher);
export default instance;



// WEBPACK FOOTER //
// ./src/stores/SessionStore.ts